/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * レンタルリクエスト
 * @export
 * @interface RentalRequestModel
 */
export interface RentalRequestModel {
    /**
     * レンタル対象となる article のハッシュキー
     * 複数指定の場合はまとめてレンタルとして処理します
     * @type {Array<string>}
     * @memberof RentalRequestModel
     */
    articleHashKeys?: Array<string>;
    /**
     * レンタル対象となる series のハッシュキー
     * まとめてレンタルの場合に指定をしてください
     * @type {string}
     * @memberof RentalRequestModel
     */
    seriesHashKey?: string;
    /**
     * ユーザーに提示しているレンタルに使用するコイン数
     * @type {number}
     * @memberof RentalRequestModel
     */
    amount?: number;
    /**
     * ユーザーに提示しているレンタルに使用するチケット数
     * @type {number}
     * @memberof RentalRequestModel
     */
    ticketCount?: number;
}

/**
 * Check if a given object implements the RentalRequestModel interface.
 */
export function instanceOfRentalRequestModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RentalRequestModelFromJSON(json: any): RentalRequestModel {
    return RentalRequestModelFromJSONTyped(json, false);
}

export function RentalRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RentalRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'articleHashKeys': !exists(json, 'articleHashKeys') ? undefined : json['articleHashKeys'],
        'seriesHashKey': !exists(json, 'seriesHashKey') ? undefined : json['seriesHashKey'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'ticketCount': !exists(json, 'ticketCount') ? undefined : json['ticketCount'],
    };
}

export function RentalRequestModelToJSON(value?: RentalRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'articleHashKeys': value.articleHashKeys,
        'seriesHashKey': value.seriesHashKey,
        'amount': value.amount,
        'ticketCount': value.ticketCount,
    };
}

